import type { SelectOption } from '@elfsight/configurator-controls';

export enum MIN_DEVICES_WIDTH {
  DESKTOP_LARGE = 1440,
  DESKTOP_MEDIUM = 1024,
  DESKTOP_SMALL = 768,
  TABLET = 480,
  MOBILE = 0
}

export const itemSpacingOptions: SelectOption<number>[] = [
  { value: 0, label: '0' },
  { value: 2, label: '2' },
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 30, label: '30' },
  { value: 40, label: '40' },
  { value: 50, label: '50' }
];

export const rowAndColumnOptions: SelectOption<number>[] = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' }
];

export const itemsOptions: SelectOption<number>[] = [
  { value: 2, label: '2' },
  { value: 4, label: '4' },
  { value: 6, label: '6' },
  { value: 8, label: '8' },
  { value: 10, label: '10' },
  { value: 12, label: '12' },
  { value: 16, label: '16' }
];

export const totalItemsLimitOptions: SelectOption<number>[] = [
  { value: 6, label: '6' },
  { value: 12, label: '12' },
  { value: 18, label: '18' },
  { value: 24, label: '24' },
  { value: 36, label: '36' },
  { value: 48, label: '48' },
  { value: 60, label: '60' },
  { value: 100, label: '100' }
];
